import { createConnectorConfig } from './PluginConnector'

const inputEditorBlockConnectionConfig = {
    blockType: 'input-editor-block',
    blockId: 'input-editor-block-1',
    blockProperty: 'answer',
    pluginDataKey: 'text' as const,
}

export const DefaultConnectors = [
    createConnectorConfig({
        id: 'plagiarism',
        pluginId: 'Plagiarism',
        blockConnectionConfigs: [inputEditorBlockConnectionConfig],
    }),
    createConnectorConfig({
        id: 'ai-detector',
        pluginId: 'AI Detection',
        blockConnectionConfigs: [inputEditorBlockConnectionConfig],
    }),
    createConnectorConfig({
        id: 'readability',
        pluginId: 'Readability',
        blockConnectionConfigs: [inputEditorBlockConnectionConfig],
    }),
    createConnectorConfig({
        id: 'soft-rules',
        pluginId: 'Soft Rules',
        blockConnectionConfigs: [inputEditorBlockConnectionConfig],
    }),
    createConnectorConfig({
        id: 'grammar',
        pluginId: 'Grammar Check',
        blockConnectionConfigs: [inputEditorBlockConnectionConfig],
    }),
    createConnectorConfig({
        id: 'sentiment',
        pluginId: 'Sentiment Analysis',
        blockConnectionConfigs: [inputEditorBlockConnectionConfig],
    }),
    createConnectorConfig({
        id: 'live-feedback',
        pluginId: 'Live Feedback',
        blockConnectionConfigs: [inputEditorBlockConnectionConfig],
    }),
    createConnectorConfig({
        id: 'custom-validation',
        pluginId: 'Custom Validation',
        blockConnectionConfigs: [inputEditorBlockConnectionConfig],
    }),
]
